import type { ChangeKeyLayer } from "@eweadn-qiankun/shared-types";

export type ChangeKeyOsSystem = "WIN" | "MAC";

function layerHasUserRemap(layer: ChangeKeyLayer): boolean {
  return (
    layer.keys?.some((entry) => Boolean(entry.sourceKeyName?.trim())) ?? false
  );
}

/** 从社区分享 payload 解析改键 Win/Mac 模式（优先 _changeKeySystem，否则从改键层推断） */
export function resolveChangeKeySystemFromPayload(
  payload?: Record<string, unknown> | null,
  changeKey?: ChangeKeyLayer[]
): ChangeKeyOsSystem {
  const raw = payload?._changeKeySystem;
  if (raw === "MAC" || raw === "WIN") return raw;
  if (raw === 1 || raw === "1") return "MAC";
  if (raw === 0 || raw === "0") return "WIN";

  const layers =
    changeKey ??
    (Array.isArray(payload?.changeKey)
      ? (payload.changeKey as ChangeKeyLayer[])
      : undefined);
  if (!layers?.length) return "WIN";

  const winActive = layers.some(
    (layer) => layer.system === "WIN" && layerHasUserRemap(layer)
  );
  const macActive = layers.some(
    (layer) => layer.system === "MAC" && layerHasUserRemap(layer)
  );
  if (macActive && !winActive) return "MAC";
  if (winActive && !macActive) return "WIN";

  const winLayers = layers.filter((layer) => layer.system === "WIN").length;
  const macLayers = layers.filter((layer) => layer.system === "MAC").length;
  if (macLayers > 0 && winLayers === 0) return "MAC";

  return "WIN";
}

export function changeKeySystemToDeviceSystem(
  system: ChangeKeyOsSystem
): number {
  return system === "MAC" ? 1 : 0;
}
